<script setup>
    import { useI18n } from 'vue-i18n';
    import DownloadGroup from "./components/DownloadGroup.vue";
    import DistiPopup from "./components/DistiPopup.vue";
    import { computed } from 'vue';

    const { t } = useI18n();

    const props = defineProps({
        dataArray: {
            type: Object,
            required: true,
        },

        productDetails: {
            type: Boolean,
            required: true,
            default: false,
        },
    });

    const showDistiDialog = computed(() => {
        return props.dataArray.some(downloadGroup =>
            downloadGroup.assets.some(downloadAssets =>
                ["Distributor", "Internal"].includes(downloadAssets.visibility)
            )
        );
    });
</script>

<template>
    <DownloadGroup
        v-for="(downloadGroup, index) in dataArray"
        :download-group="downloadGroup"
        :index="index"
        :product-details="productDetails"
    ></DownloadGroup>
    <DistiPopup v-if="showDistiDialog"></DistiPopup>
</template>
